import { chatAgentBackgroundColor, chatAgentFontColor, userMessageDropShadow } from 'globals/colors';

const styles = {
  message: {
    fontSize: '12px',
    fontWeight: '400',
    padding: '7px 12px',
    borderRadius: '9px 9px 9px 0',
    display: 'inline-block',
    maxWidth: '250px',
    lineHeight: '16px',
    color: chatAgentFontColor,
    backgroundColor: chatAgentBackgroundColor,
    wordWrap: 'break-word',
    boxShadow: `0 0 7px 0 ${userMessageDropShadow}`,
    alignSelf: 'flex-start',
  },
  messageContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  wrapper: {
    display: 'flex',
  },
  emptyAvatar: {
    width: 30,
  },
  userAvatar: {
    margin: '0px 5px',
  },
};

export default styles;
